
import { Observable, Subject, Subscription, of as observableOf } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as howler from 'howler';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import 'rxjs/Rx';
import { catchError, filter, map } from 'rxjs/operators';
import { FeedbackAudio } from '../../components/notifications/feedback-audio.class';
import { AppState } from '../../interfaces/app-state.interface';
import { SettingsService } from '../../services/settings/settings.service';
import { DisposableSafelly } from '../disposable-safelly/disposable-safelly.component';
import { BrowserUtilsService } from './../../services/browser-utils.service';

const longPoolingInterval = 5000;

// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
@AutoUnsubscribe()
@Injectable()
export class ChatAssessorService extends DisposableSafelly {

    public chatEndSubscription: Subscription;
    public getMessagesSubscription: Subscription;

    // Emit os status de envio (http) da msg do usuario
    public userMessageFeedback$: Observable<any>;

    // Sequência que deve ser enviada junto com as chamadas do usuário
    public sequenceNumber: number = 0;

    // Emit a msg do agente/bot/sistema (qualquer uma exeto do usuario!)
    public assessorMessagens$: Observable<any>;

    // Resposta do get do session id
    public sessionID;

    // Recebe as configs do chat
    private config;

    // Assunto recebido via get
    private subject;

    // Login subscribe
    private authSubscribe: Subscription;

    // Recebe o status do login do usuario
    private logged: any = null;

    private assessorMessagens: Subject<any>;

    private userMessageFeedback: Subject<any>;
    private chatEnded: boolean;

    private msgObj = {
        messages: [
            {
                type: 'AgentTyping',
                message: {},
            },
            {
                type: 'ChatMessage',
                message: {
                    text: 'ok',
                    name: 'Ramon Pereira',
                    agentId: '0056A000000IfPa',
                },
            },
            {
                type: 'AgentTyping',
                message: {},
            },
            {
                type: 'ChatMessage',
                message: {
                    text: 'vamos fazer assim',
                    name: 'Ramon Pereira',
                    agentId: '0056A000000IfPa',
                },
            },
            {
                type: 'AgentNotTyping',
                message: {},
            },
            {
                type: 'CustomEvent',
                message: {
                    type: 'toroInfo',
                    data: '{\"urlPhoto\":\"https://toroctvm--torodev--c.cs68.content.force.com/servlet/servlet.ImageServer?id=0151D0000005N7F&oid=00D1D0000008tP5&lastMod=1521055862000\"}',
                },
            },
        ],
        sequence: 12,
        offset: 23990142,
    };

    private lastMessageWasError: boolean;

    // Variáveis para tratar o som de feedback de mensagem recebida
    private feedbackAudio;
    private notificationSound: any;
    private notificationSoundSrc: string = 'assets/audio/sound_5.wav';

    constructor(
        private httpClient: HttpClient,
        private store: Store<AppState>,
        private bUtils: BrowserUtilsService,
        private settingsService: SettingsService,
    ) {
        super();

        // assessor messagens
        this.assessorMessagens = new Subject();
        this.assessorMessagens$ = this.assessorMessagens.asObservable();

        // messagens user feedback
        this.userMessageFeedback = new Subject();
        this.userMessageFeedback$ = this.userMessageFeedback.asObservable();

        // Verifica o login
        this.subscribeLogin();

        // configs
        this.config = this.settingsService.getConfigurationKeyValue('csf');

        // som de feedback quando o assessor manda mensagem
        this.feedbackAudio = new FeedbackAudio('/assets/audio/sound_5.wav', 5000);

        this.notificationSound = new howler.Howl({
            src: [this.notificationSoundSrc],
            volume: 1,
            loop: false,
            html5: true,
        });
    }

    // Verifica o login
    public subscribeLogin() {

        // USUARIOS PARA TESTE

        // user: 18361009060
        // pass: xptoto

        // 37325777752 - 900 - Identified - 123456
        // 54659050343 - 1000 - Registred - 123456
        // 26683375267 - 856 - Activated - 123456

        this.authSubscribe = this.store
            .select((state) => state.authentication)
            .subscribe((data) => this.logged = data.currentUser);
    }

    /**
     * Inicia uma conexão com o salesforce
     */
    public getSessionID(subject: string = '') {

        this.assessorMessagens.next({ message: this.createMessage('Iniciando chat com assessor...', 'ChatMsg'), type: 'Assessor' });

        // Usuário anônimo
        if (!this.logged) {

            this.assessorMessagens.next({
                message: this.createMessage('Você precisa estar logado para iniciar um chat.', 'ChatAlerts'),
                type: 'Assessor',
            });

        } else {

            this.subject = subject;

            const config = this.settingsService.getConfigurationKeyValue('csf');
            let httpHeader = new HttpHeaders({});
            httpHeader = httpHeader.set('X-LIVEAGENT-API-VERSION', '41');
            httpHeader = httpHeader.set('Content-Type', 'application/json; charset=UTF-8');
            httpHeader = httpHeader.set('X-LIVEAGENT-AFFINITY', 'null');

            this.httpClient
                .get(this.config.urlSessionId, { headers: httpHeader})
                .pipe(
                map((result) => {
                    if (result && result.hasOwnProperty('key')) {

                        this.sessionID = result;
                        this.sequenceNumber = 1;
                        this.chatRequest();

                    } else {
                        this.assessorMessagens.next({
                            message: this.createMessage('Ocorreu algum erro ao iniciar o chat.', 'ChatAlerts'),
                            type: 'Assessor',
                        });
                    }
                }),
                catchError((error) => {
                    this.assessorMessagens.next({
                        message: this.createMessage('Erro ao requisitar um id de sessão.', 'ChatAlerts'),
                        type: 'Assessor',
                    });
                    return observableOf(error);
                }),)
                .subscribe();
        }
    }

    /**
     * Envia as informacoes do usuario para o agente
     * poder iniciar um chat
     */
    public chatRequest() {

        /**
         * criar metodo/class para montar o body!
         */
        const body = {

            buttonId: this.config.buttonId,
            language: this.bUtils.getLanguage(),
            sessionId: this.sessionID.id,
            userAgent: this.bUtils.getUserAgent(),
            visitorName: this.logged.name,
            deploymentId: this.config.deploymentId,
            organizationId: this.config.organizationId,
            screenResolution: this.bUtils.getScreenResolution(),
            prechatDetails: [
                {
                    label: 'Name',
                    value: this.logged.name,
                    transcriptFields: [],
                    displayToAgent: true,
                },
                {
                    label: 'Assunto',
                    value: this.subject,
                    transcriptFields: [
                        'assunto__c',
                    ],
                    displayToAgent: true,
                },
                {
                    label: 'Plataforma',
                    value: 'HUB',
                    transcriptFields: [
                        'Platform',
                    ],
                    displayToAgent: true,
                },
                // {
                //     label: 'Página web',
                //     value: 'http://google.com',
                //     transcriptFields: [
                //         'ReferrerUri',
                //     ],
                //     displayToAgent: true
                // },
                {
                    label: 'Navegador',
                    value: this.bUtils.getBrowser(),
                    transcriptFields: [
                        'Browser',
                    ],
                    displayToAgent: true,
                },
                {
                    label: 'idUsuario__c',
                    value: this.logged.userId,
                    entityMaps: [
                        {
                            entityName: 'contact',
                            fieldName: 'idUsuario__c',
                        },
                    ],
                    transcriptFields: [
                        'idUsuario__c',
                    ],
                    displayToAgent: true,
                },
            ],
            prechatEntities: [
                {
                    entityName: 'Contact',
                    saveToTranscript: 'Contact',
                    linkToEntityName: 'Contact',
                    entityFieldsMaps: [
                        {
                            fieldName: 'idUsuario__c',
                            label: 'idUsuario__c',
                            doFind: true,
                            isExactMatch: true,
                            doCreate: false,
                        },
                    ],
                },
            ],
            receiveQueueUpdates: true,
            isPost: true,
        };

        const sessionIdHeader = new HttpHeaders({
            'X-LIVEAGENT-API-VERSION': '41',
            'X-LIVEAGENT-AFFINITY': this.sessionID.affinityToken,
            'X-LIVEAGENT-SESSION-KEY': this.sessionID.key,
            'X-LIVEAGENT-SEQUENCE': this.sequenceNumber.toString(),
            'Content-Type': 'text/plain',
        });

        this.sequenceNumber++;

        this.httpClient
            .post(this.config.urlChatRequest, body, { headers: sessionIdHeader, responseType: 'text' })
            .pipe(
                catchError((err) => {
                    this.assessorMessagens.next({
                        message: this.createMessage('Erro em solicitar um novo chat.', 'ChatAlerts'),
                        type: 'Assessor',
                    });
                    return observableOf(err);
                }),
            )
            .subscribe((res) => {
                this.chatEnded = false;
                this.getMessages();
            });
    }

    /**
     * Get and send messages
     * polling para receber as msg do usuario
     */
    public getMessages() {

        if (this.chatEnded) return false;

        let getMessagesHeader = new HttpHeaders({});
        getMessagesHeader = getMessagesHeader.set('X-LIVEAGENT-API-VERSION', '41');
        getMessagesHeader = getMessagesHeader.set('X-LIVEAGENT-AFFINITY', this.sessionID.affinityToken ? this.sessionID.affinityToken : null);
        getMessagesHeader = getMessagesHeader.set('X-LIVEAGENT-SESSION-KEY', this.sessionID.key ? this.sessionID.key : null);

        this.getMessagesSubscription = this.httpClient
            .get(this.config.urlGetMessages, { headers: getMessagesHeader })
            .pipe(
            catchError((error) => {
                if (!this.lastMessageWasError) {

                    this.lastMessageWasError = true;

                    this.assessorMessagens.next({
                        message: this.createMessage('Erro na conexão.', 'ChatAlerts'),
                        type: 'Assessor',
                    });

                    this.endChat('connection error')
                        .subscribe();
                }

                return observableOf(error);

            }),
            filter((i) => !this.chatEnded))
            .subscribe((data) => {

                if (data && data.messages) {

                    this.lastMessageWasError = false;

                    this.assessorMessagens.next({
                        message: data,
                        type: 'Assessor',
                    });

                    this.notificationSound.play();
                }

                setTimeout(() => this.getMessages(), longPoolingInterval);

            });
    }

    /**
     * executa o post da msg do usuario
     * em caso de erro emit um objeto com o
     * tipo e o id da msg
     *
     * @param msg a ser enviada
     */
    public sendMessagens(msg) {

        let sendMessagesHeader = new HttpHeaders({});
        sendMessagesHeader = sendMessagesHeader.set('X-LIVEAGENT-API-VERSION', '42');
        sendMessagesHeader = sendMessagesHeader.set('X-LIVEAGENT-AFFINITY', this.sessionID.affinityToken ? this.sessionID.affinityToken : null);
        sendMessagesHeader = sendMessagesHeader.set('X-LIVEAGENT-SESSION-KEY', this.sessionID.key ? this.sessionID.key : null);
        sendMessagesHeader = sendMessagesHeader.set('Content-Type', 'text/plain');

        this.httpClient.post(
                this.config.urlSendMessages,
                { text: msg.message },
                { headers: sendMessagesHeader, responseType: 'text' },
            )
            .subscribe(
                (res) => null,
                (err) => this.userMessageFeedback.next({ type: 'error', id: msg.id }),
            );
    }

    /**
     * executa o post da msg que o usuário está digitando
     * em caso de erro emit um objeto com o
     * tipo e o id da msg
     *
     * @param msg a ser enviada
     */
    public sendTypingMessage(msg, position) {
        let sendMessagesHeader = new HttpHeaders({});
        const config = this.settingsService.getConfigurationKeyValue('csf');
        sendMessagesHeader = sendMessagesHeader.set('X-LIVEAGENT-API-VERSION', '42');
        sendMessagesHeader = sendMessagesHeader.set('X-LIVEAGENT-AFFINITY', this.sessionID.affinityToken ? this.sessionID.affinityToken : null);
        sendMessagesHeader = sendMessagesHeader.set('X-LIVEAGENT-SESSION-KEY', this.sessionID.key ? this.sessionID.key : null);
        sendMessagesHeader = sendMessagesHeader.set('X-LIVEAGENT-SEQUENCE', this.sequenceNumber.toString());
        this.sequenceNumber++;
        this.httpClient.post(
                config.urlTypingMessage,
                { position, text: msg.message },
                { headers: sendMessagesHeader },
            )
            .subscribe(
                (res) => null,
                (err) => this.userMessageFeedback.next({ type: 'error', id: msg.id }),
            );
    }

    /**
     * Cria um objeto msg para emitir
     *
     * @param text texto da mesg
     */
    public createMessage(text, type: string = null) {
        return {
            messages: [
                {
                    type,
                    message: { text },
                },
            ],
            sequence: 0,
        };
    }

    /**
     * Finaliza a conversa com o assessor
     *
     * @param reason Razão de ter terminado o chat
     */
    public endChat(reason: string) {

        // this.chatEndedSubject.next(true);
        this.chatEnded = true;
        let header = new HttpHeaders({});
        header = header.set('X-LIVEAGENT-API-VERSION', '42');
        header = header.set('X-LIVEAGENT-AFFINITY', this.sessionID.affinityToken);
        header = header.set('X-LIVEAGENT-SESSION-KEY', this.sessionID.key);
        this.sequenceNumber = 1;

        return this.httpClient.post( this.config.urlChatEnd, {reason: 'client'}, { headers: header, responseType: 'text'});
    }

    public ngOnDestroy() {
        this.authSubscribe.unsubscribe();
        this.chatEnded = true;
    }

}
